// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── 좌우 분할 컨테이너 ─────────────────────────────────────── */
.sm-split {
  display: flex;
  height: 100%;
  overflow: hidden;
}
/* 드래그 중 텍스트 선택 방지 */
.sm-split-dragging {
  -webkit-user-select: none;
          user-select: none;
  cursor: col-resize;
}

/* 왼쪽 패널 */
.sm-left {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 8px 12px 12px;
  overflow-y: auto;
  overflow-x: hidden;
  flex-shrink: 0;
  min-width: 0;
  box-sizing: border-box;
}

/* 드래그 구분선 */
.sm-divider {
  width: 6px;
  flex-shrink: 0;
  background: #e0e3e8;
  cursor: col-resize;
  transition: background 0.15s;
  position: relative;
}
.sm-divider:hover,
.sm-divider.dragging {
  background: #1976d2;
}

/* 오른쪽 패널 */
.sm-right {
  flex: 1 1;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  overflow: hidden;
}
.sm-right-placeholder {
  font-size: 14px;
  color: #ccc;
  pointer-events: none;
}

/* ── 카드 ─────────────────────────────────────────────────── */
.sm-card {
  background: #fff;
  border: 1px solid #e0e3e8;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.sm-card-header {
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 700;
  color: #222;
  background: #f0f2f7;
  border-bottom: 1px solid #e0e3e8;
}
.sm-card-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 카드 내 서브 섹션 구분선 */
.sm-card-divider {
  height: 1px;
  background: #ebedf2;
}

/* 서브 섹션 패딩 */
.sm-sub {
  padding: 14px;
}
.sm-sub-title {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

/* ── 폼 행 ──────────────────────────────────────────────────── */
.sm-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
.sm-row-col {
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.sm-row-right {
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}
.sm-lbl {
  font-size: 12px;
  color: #555;
  font-weight: 500;
  min-width: 76px;
  flex-shrink: 0;
}
.sm-inline {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.sm-unit {
  font-size: 12px;
  color: #555;
}
.sm-hint {
  font-size: 11px;
  color: #999;
}

/* ── 입력 요소 ──────────────────────────────────────────────── */
.sm-input {
  border: 1px solid #d0d3d8;
  border-radius: 4px;
  padding: 5px 8px;
  font-size: 12px;
  color: #333;
  outline: none;
  transition: border-color 0.15s;
  background: #fff;
}
.sm-input:focus {
  border-color: #1976d2;
}
/* 시/일 입력 (숫자 단위) */
.sm-input-sm {
  width: 52px;
  text-align: center;
}
/* 경로 입력 (전체 너비) */
.sm-input-full {
  width: 100%;
  box-sizing: border-box;
}

.sm-select {
  border: 1px solid #d0d3d8;
  border-radius: 4px;
  padding: 5px 8px;
  font-size: 12px;
  color: #333;
  background: #fff;
  cursor: pointer;
  outline: none;
}
.sm-select:focus {
  border-color: #1976d2;
}

/* 토글 스위치 */
.sm-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.sm-toggle input { display: none; }
.sm-toggle-slider {
  position: relative;
  width: 40px;
  height: 22px;
  background: #ccc;
  border-radius: 11px;
  transition: background 0.2s;
  flex-shrink: 0;
}
.sm-toggle-slider::after {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  background: #fff;
  border-radius: 50%;
  top: 3px;
  left: 3px;
  transition: transform 0.2s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.22);
}
.sm-toggle input:checked + .sm-toggle-slider {
  background: #1976d2;
}
.sm-toggle input:checked + .sm-toggle-slider::after {
  transform: translateX(18px);
}
.sm-toggle-text {
  font-size: 12px;
  font-weight: 600;
  color: #444;
  min-width: 24px;
}

/* ── 공통 버튼 ──────────────────────────────────────────────── */
.sm-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 7px 14px;
  border: none;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, opacity 0.15s;
}
.sm-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.sm-btn-primary {
  background: #1976d2;
  color: #fff;
}
.sm-btn-primary:hover:not(:disabled) { background: #1565c0; }
.sm-btn-secondary {
  background: #f0f2f5;
  color: #333;
  border: 1px solid #d0d3d8;
}
.sm-btn-secondary:hover:not(:disabled) { background: #e4e7ee; }
/* 즉시 백업 버튼 (조금 크게) */
.sm-btn-backup {
  font-size: 13px;
  padding: 9px 18px;
}

/* 스피너 */
.sm-spinner {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid rgba(255,255,255,0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: sm-spin 0.7s linear infinite;
}
@keyframes sm-spin { to { transform: rotate(360deg); } }

/* ── 즉시 백업 결과 ─────────────────────────────────────────── */
.sm-backup-status {
  margin: 8px 0;
  font-size: 12px;
  color: #1976d2;
}
.sm-backup-result {
  margin: 10px 0;
  padding: 8px 12px;
  border-radius: 5px;
  font-size: 12px;
  line-height: 1.85;
}
.sm-backup-result.ok {
  background: #e8f5e9;
  border: 1px solid #a5d6a7;
  color: #2e7d32;
}
.sm-backup-result.fail {
  background: #ffebee;
  border: 1px solid #ef9a9a;
  color: #c62828;
}
.sm-net-error {
  font-size: 11px;
  color: #e65100;
}
.sm-backup-info {
  margin-top: 12px;
  font-size: 11px;
  color: #888;
  line-height: 1.9;
}
.sm-backup-info .sm-lbl {
  color: #555;
  min-width: 60px;
}

/* 복구 안내 텍스트 */
.sm-restore-desc {
  font-size: 12px;
  color: #666;
  margin: 0 0 10px;
}

/* 저장 결과 메시지 */
.sm-save-ok  { font-size: 12px; color: #2e7d32; }
.sm-save-err { font-size: 12px; color: #c62828; }

/* 새로고침 버튼 */
.sm-refresh-btn {
  background: none;
  border: 1px solid #d0d3d8;
  border-radius: 4px;
  padding: 3px 9px;
  font-size: 11px;
  color: #555;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;
}
.sm-refresh-btn:hover { background: #e4e7ee; }

/* ── 이력 테이블 ─────────────────────────────────────────────── */
.sm-loading {
  padding: 24px;
  text-align: center;
  font-size: 12px;
  color: #bbb;
}
.sm-table-wrap {
  overflow-x: auto;
}
.sm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  /* 테이블 최소 너비: 컬럼 합산 기준 */
  min-width: 480px;
}
.sm-table thead tr { background: #f8f9fb; }
.sm-table th {
  padding: 7px 10px;
  text-align: left;
  font-size: 11px;
  font-weight: 700;
  color: #444;
  border-bottom: 2px solid #e0e3e8;
  white-space: nowrap;
}
.sm-table td {
  padding: 7px 10px;
  border-bottom: 1px solid #f0f2f5;
  vertical-align: middle;
}
.sm-table tbody tr:hover:not(.sm-row-fail) { background: #f5f7fa; }
/* 로컬+IPDISK 모두 실패 행 */
.sm-row-fail { background: #fff0f0 !important; }
.sm-empty {
  text-align: center;
  padding: 28px !important;
  color: #bbb;
  font-size: 12px;
}

.sm-col-dt {
  white-space: nowrap;
  font-size: 11px;
  color: #555;
}
/* 파일명: 말줄임 처리 */
.sm-col-file {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: 'Consolas', monospace;
  font-size: 11px;
}
.sm-col-r { text-align: right; white-space: nowrap; }
.sm-col-c { text-align: center; }

/* 유형 배지 */
.sm-badge {
  display: inline-block;
  padding: 2px 7px;
  border-radius: 9px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
.sm-badge.auto   { background: #f0f2f5; color: #666; }
.sm-badge.manual { background: #e3f2fd; color: #1565c0; }

/* 다운로드 버튼 */
.sm-dl-btn {
  padding: 3px 8px;
  border-radius: 3px;
  font-size: 11px;
  border: 1px solid #1976d2;
  background: #e3f2fd;
  color: #1565c0;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;
}
.sm-dl-btn:hover:not(:disabled) { background: #bbdefb; }
.sm-dl-btn:disabled {
  border-color: #d0d3d8;
  background: #f5f5f5;
  color: #bbb;
  cursor: not-allowed;
}

/* 페이지네이션 */
.sm-pagination {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  padding: 10px 0;
  font-size: 12px;
  color: #555;
}
.sm-pagination button {
  padding: 4px 10px;
  border: 1px solid #d0d3d8;
  border-radius: 3px;
  background: #fff;
  cursor: pointer;
  font-size: 11px;
  color: #444;
  transition: background 0.15s;
}
.sm-pagination button:disabled { color: #ccc; cursor: not-allowed; }
.sm-pagination button:hover:not(:disabled) { background: #f0f2f5; }

/* ── 복구 절차 모달 ─────────────────────────────────────────── */
.sm-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.sm-modal {
  background: #fff;
  border-radius: 10px;
  width: 520px;
  max-width: 95vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
}
.sm-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 16px;
  border-bottom: 1px solid #e0e3e8;
  font-size: 14px;
  font-weight: 600;
  color: #222;
  flex-shrink: 0;
}
.sm-modal-close {
  background: none;
  border: none;
  font-size: 15px;
  color: #888;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 3px;
}
.sm-modal-close:hover { background: #f0f0f0; }

.sm-modal-body {
  overflow-y: auto;
  padding: 14px 16px;
  flex: 1 1;
}
.sm-modal-footer {
  padding: 10px 16px;
  border-top: 1px solid #e0e3e8;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}

/* 주의사항 박스 */
.sm-restore-warn {
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 5px;
  padding: 10px 12px;
  margin-bottom: 14px;
  font-size: 12px;
  color: #555;
}
.sm-restore-warn strong {
  display: block;
  margin-bottom: 3px;
  color: #e65100;
}
.sm-restore-warn p { margin: 0; }

.sm-restore-section {
  margin-bottom: 14px;
}
.sm-restore-section h4 {
  font-size: 12px;
  font-weight: 700;
  color: #333;
  margin: 0 0 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid #eee;
}
.sm-restore-section ul {
  margin: 0;
  padding-left: 16px;
  font-size: 12px;
  color: #555;
  line-height: 1.9;
}

/* 복구 단계 */
.sm-restore-step {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
  align-items: flex-start;
}
.sm-step-num {
  min-width: 22px;
  height: 22px;
  background: #1976d2;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
  margin-top: 1px;
}
.sm-step-body { flex: 1 1; min-width: 0; }
.sm-step-title {
  font-size: 12px;
  color: #444;
  margin-bottom: 5px;
}
.sm-step-example {
  font-size: 11px;
  color: #888;
  margin-top: 4px;
  word-break: break-all;
  line-height: 1.6;
}

/* 명령어 행 */
.sm-cmd-line {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  padding: 5px 8px;
  margin-bottom: 4px;
}
.sm-cmd-line code {
  flex: 1 1;
  font-size: 11px;
  font-family: 'Consolas', 'Courier New', monospace;
  color: #333;
  word-break: break-all;
}
.sm-copy-btn {
  background: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 10px;
  padding: 2px 6px;
  cursor: pointer;
  color: #666;
  flex-shrink: 0;
  white-space: nowrap;
  transition: background 0.1s;
}
.sm-copy-btn.copied {
  background: #e8f5e9;
  border-color: #a5d6a7;
  color: #2e7d32;
}
.sm-copy-btn:hover:not(.copied) { background: #e8e8e8; }

/* 복구 후 팁 */
.sm-restore-tip {
  background: #e3f2fd;
  border: 1px solid #90caf9;
  border-radius: 5px;
  padding: 9px 12px;
  font-size: 12px;
  color: #1565c0;
  line-height: 1.7;
}

/* ── 접근 불가 메시지 ───────────────────────────────────────── */
.sm-no-access {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  font-size: 14px;
  color: #aaa;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/SystemManagePage.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;AACA,oBAAoB;AACpB;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,8DAA8D;AAC9D;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA,mBAAmB;AACnB;EACE,WAAW;EACX,kBAAkB;AACpB;AACA,kBAAkB;AAClB;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,mBAAmB,aAAa,EAAE;AAClC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,sCAAsC;AACxC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA,uCAAuC,mBAAmB,EAAE;AAC5D;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA,yCAAyC,mBAAmB,EAAE;AAC9D,qBAAqB;AACrB;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,QAAQ;AACR;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;AACzC;AACA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD,4DAA4D;AAC5D;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,cAAc;AACd,eAAe,eAAe,EAAE,cAAc,EAAE;AAChD,eAAe,eAAe,EAAE,cAAc,EAAE;;AAEhD,YAAY;AACZ;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,wBAAwB,mBAAmB,EAAE;;AAE7C,8DAA8D;AAC9D;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;AACA,qBAAqB,mBAAmB,EAAE;AAC1C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;AACA,6CAA6C,mBAAmB,EAAE;AAClE,sBAAsB;AACtB,eAAe,8BAA8B,EAAE;AAC/C;EACE,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;AACjB;AACA,YAAY,iBAAiB,EAAE,mBAAmB,EAAE;AACpD,YAAY,kBAAkB,EAAE;;AAEhC,UAAU;AACV;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,mBAAmB,mBAAmB,EAAE,WAAW,EAAE;AACrD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;;AAExD,YAAY;AACZ;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,kCAAkC,mBAAmB,EAAE;AACvD;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,4BAA4B;AAC9B;AACA,iCAAiC,WAAW,EAAE,mBAAmB,EAAE;AACnE,6CAA6C,mBAAmB,EAAE;;AAElE,4DAA4D;AAC5D;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;AACT;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;AACA,qBAAqB,SAAS,EAAE;;AAEhC;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA,gBAAgB,SAAO,EAAE,YAAY,EAAE;AACvC;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,SAAO;EACP,eAAe;EACf,iDAAiD;EACjD,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,kCAAkC,mBAAmB,EAAE;;AAEvD,WAAW;AACX;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,WAAW;AACb","sourcesContent":["/* ── 좌우 분할 컨테이너 ─────────────────────────────────────── */\n.sm-split {\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n}\n/* 드래그 중 텍스트 선택 방지 */\n.sm-split-dragging {\n  user-select: none;\n  cursor: col-resize;\n}\n\n/* 왼쪽 패널 */\n.sm-left {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 12px 8px 12px 12px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex-shrink: 0;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n/* 드래그 구분선 */\n.sm-divider {\n  width: 6px;\n  flex-shrink: 0;\n  background: #e0e3e8;\n  cursor: col-resize;\n  transition: background 0.15s;\n  position: relative;\n}\n.sm-divider:hover,\n.sm-divider.dragging {\n  background: #1976d2;\n}\n\n/* 오른쪽 패널 */\n.sm-right {\n  flex: 1;\n  background: #fafafa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n  overflow: hidden;\n}\n.sm-right-placeholder {\n  font-size: 14px;\n  color: #ccc;\n  pointer-events: none;\n}\n\n/* ── 카드 ─────────────────────────────────────────────────── */\n.sm-card {\n  background: #fff;\n  border: 1px solid #e0e3e8;\n  border-radius: 8px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.sm-card-header {\n  padding: 10px 14px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #222;\n  background: #f0f2f7;\n  border-bottom: 1px solid #e0e3e8;\n}\n.sm-card-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* 카드 내 서브 섹션 구분선 */\n.sm-card-divider {\n  height: 1px;\n  background: #ebedf2;\n}\n\n/* 서브 섹션 패딩 */\n.sm-sub {\n  padding: 14px;\n}\n.sm-sub-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 12px;\n}\n\n/* ── 폼 행 ──────────────────────────────────────────────────── */\n.sm-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n}\n.sm-row-col {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n.sm-row-right {\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n}\n.sm-lbl {\n  font-size: 12px;\n  color: #555;\n  font-weight: 500;\n  min-width: 76px;\n  flex-shrink: 0;\n}\n.sm-inline {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n.sm-unit {\n  font-size: 12px;\n  color: #555;\n}\n.sm-hint {\n  font-size: 11px;\n  color: #999;\n}\n\n/* ── 입력 요소 ──────────────────────────────────────────────── */\n.sm-input {\n  border: 1px solid #d0d3d8;\n  border-radius: 4px;\n  padding: 5px 8px;\n  font-size: 12px;\n  color: #333;\n  outline: none;\n  transition: border-color 0.15s;\n  background: #fff;\n}\n.sm-input:focus {\n  border-color: #1976d2;\n}\n/* 시/일 입력 (숫자 단위) */\n.sm-input-sm {\n  width: 52px;\n  text-align: center;\n}\n/* 경로 입력 (전체 너비) */\n.sm-input-full {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.sm-select {\n  border: 1px solid #d0d3d8;\n  border-radius: 4px;\n  padding: 5px 8px;\n  font-size: 12px;\n  color: #333;\n  background: #fff;\n  cursor: pointer;\n  outline: none;\n}\n.sm-select:focus {\n  border-color: #1976d2;\n}\n\n/* 토글 스위치 */\n.sm-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n.sm-toggle input { display: none; }\n.sm-toggle-slider {\n  position: relative;\n  width: 40px;\n  height: 22px;\n  background: #ccc;\n  border-radius: 11px;\n  transition: background 0.2s;\n  flex-shrink: 0;\n}\n.sm-toggle-slider::after {\n  content: '';\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 50%;\n  top: 3px;\n  left: 3px;\n  transition: transform 0.2s;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.22);\n}\n.sm-toggle input:checked + .sm-toggle-slider {\n  background: #1976d2;\n}\n.sm-toggle input:checked + .sm-toggle-slider::after {\n  transform: translateX(18px);\n}\n.sm-toggle-text {\n  font-size: 12px;\n  font-weight: 600;\n  color: #444;\n  min-width: 24px;\n}\n\n/* ── 공통 버튼 ──────────────────────────────────────────────── */\n.sm-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 7px 14px;\n  border: none;\n  border-radius: 5px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s, opacity 0.15s;\n}\n.sm-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n.sm-btn-primary {\n  background: #1976d2;\n  color: #fff;\n}\n.sm-btn-primary:hover:not(:disabled) { background: #1565c0; }\n.sm-btn-secondary {\n  background: #f0f2f5;\n  color: #333;\n  border: 1px solid #d0d3d8;\n}\n.sm-btn-secondary:hover:not(:disabled) { background: #e4e7ee; }\n/* 즉시 백업 버튼 (조금 크게) */\n.sm-btn-backup {\n  font-size: 13px;\n  padding: 9px 18px;\n}\n\n/* 스피너 */\n.sm-spinner {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border: 2px solid rgba(255,255,255,0.35);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: sm-spin 0.7s linear infinite;\n}\n@keyframes sm-spin { to { transform: rotate(360deg); } }\n\n/* ── 즉시 백업 결과 ─────────────────────────────────────────── */\n.sm-backup-status {\n  margin: 8px 0;\n  font-size: 12px;\n  color: #1976d2;\n}\n.sm-backup-result {\n  margin: 10px 0;\n  padding: 8px 12px;\n  border-radius: 5px;\n  font-size: 12px;\n  line-height: 1.85;\n}\n.sm-backup-result.ok {\n  background: #e8f5e9;\n  border: 1px solid #a5d6a7;\n  color: #2e7d32;\n}\n.sm-backup-result.fail {\n  background: #ffebee;\n  border: 1px solid #ef9a9a;\n  color: #c62828;\n}\n.sm-net-error {\n  font-size: 11px;\n  color: #e65100;\n}\n.sm-backup-info {\n  margin-top: 12px;\n  font-size: 11px;\n  color: #888;\n  line-height: 1.9;\n}\n.sm-backup-info .sm-lbl {\n  color: #555;\n  min-width: 60px;\n}\n\n/* 복구 안내 텍스트 */\n.sm-restore-desc {\n  font-size: 12px;\n  color: #666;\n  margin: 0 0 10px;\n}\n\n/* 저장 결과 메시지 */\n.sm-save-ok  { font-size: 12px; color: #2e7d32; }\n.sm-save-err { font-size: 12px; color: #c62828; }\n\n/* 새로고침 버튼 */\n.sm-refresh-btn {\n  background: none;\n  border: 1px solid #d0d3d8;\n  border-radius: 4px;\n  padding: 3px 9px;\n  font-size: 11px;\n  color: #555;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s;\n}\n.sm-refresh-btn:hover { background: #e4e7ee; }\n\n/* ── 이력 테이블 ─────────────────────────────────────────────── */\n.sm-loading {\n  padding: 24px;\n  text-align: center;\n  font-size: 12px;\n  color: #bbb;\n}\n.sm-table-wrap {\n  overflow-x: auto;\n}\n.sm-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n  /* 테이블 최소 너비: 컬럼 합산 기준 */\n  min-width: 480px;\n}\n.sm-table thead tr { background: #f8f9fb; }\n.sm-table th {\n  padding: 7px 10px;\n  text-align: left;\n  font-size: 11px;\n  font-weight: 700;\n  color: #444;\n  border-bottom: 2px solid #e0e3e8;\n  white-space: nowrap;\n}\n.sm-table td {\n  padding: 7px 10px;\n  border-bottom: 1px solid #f0f2f5;\n  vertical-align: middle;\n}\n.sm-table tbody tr:hover:not(.sm-row-fail) { background: #f5f7fa; }\n/* 로컬+IPDISK 모두 실패 행 */\n.sm-row-fail { background: #fff0f0 !important; }\n.sm-empty {\n  text-align: center;\n  padding: 28px !important;\n  color: #bbb;\n  font-size: 12px;\n}\n\n.sm-col-dt {\n  white-space: nowrap;\n  font-size: 11px;\n  color: #555;\n}\n/* 파일명: 말줄임 처리 */\n.sm-col-file {\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: 'Consolas', monospace;\n  font-size: 11px;\n}\n.sm-col-r { text-align: right; white-space: nowrap; }\n.sm-col-c { text-align: center; }\n\n/* 유형 배지 */\n.sm-badge {\n  display: inline-block;\n  padding: 2px 7px;\n  border-radius: 9px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.sm-badge.auto   { background: #f0f2f5; color: #666; }\n.sm-badge.manual { background: #e3f2fd; color: #1565c0; }\n\n/* 다운로드 버튼 */\n.sm-dl-btn {\n  padding: 3px 8px;\n  border-radius: 3px;\n  font-size: 11px;\n  border: 1px solid #1976d2;\n  background: #e3f2fd;\n  color: #1565c0;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s;\n}\n.sm-dl-btn:hover:not(:disabled) { background: #bbdefb; }\n.sm-dl-btn:disabled {\n  border-color: #d0d3d8;\n  background: #f5f5f5;\n  color: #bbb;\n  cursor: not-allowed;\n}\n\n/* 페이지네이션 */\n.sm-pagination {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: center;\n  padding: 10px 0;\n  font-size: 12px;\n  color: #555;\n}\n.sm-pagination button {\n  padding: 4px 10px;\n  border: 1px solid #d0d3d8;\n  border-radius: 3px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 11px;\n  color: #444;\n  transition: background 0.15s;\n}\n.sm-pagination button:disabled { color: #ccc; cursor: not-allowed; }\n.sm-pagination button:hover:not(:disabled) { background: #f0f2f5; }\n\n/* ── 복구 절차 모달 ─────────────────────────────────────────── */\n.sm-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n.sm-modal {\n  background: #fff;\n  border-radius: 10px;\n  width: 520px;\n  max-width: 95vw;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.2);\n}\n.sm-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 13px 16px;\n  border-bottom: 1px solid #e0e3e8;\n  font-size: 14px;\n  font-weight: 600;\n  color: #222;\n  flex-shrink: 0;\n}\n.sm-modal-close {\n  background: none;\n  border: none;\n  font-size: 15px;\n  color: #888;\n  cursor: pointer;\n  padding: 2px 6px;\n  border-radius: 3px;\n}\n.sm-modal-close:hover { background: #f0f0f0; }\n\n.sm-modal-body {\n  overflow-y: auto;\n  padding: 14px 16px;\n  flex: 1;\n}\n.sm-modal-footer {\n  padding: 10px 16px;\n  border-top: 1px solid #e0e3e8;\n  display: flex;\n  justify-content: flex-end;\n  flex-shrink: 0;\n}\n\n/* 주의사항 박스 */\n.sm-restore-warn {\n  background: #fff8e1;\n  border: 1px solid #ffe082;\n  border-radius: 5px;\n  padding: 10px 12px;\n  margin-bottom: 14px;\n  font-size: 12px;\n  color: #555;\n}\n.sm-restore-warn strong {\n  display: block;\n  margin-bottom: 3px;\n  color: #e65100;\n}\n.sm-restore-warn p { margin: 0; }\n\n.sm-restore-section {\n  margin-bottom: 14px;\n}\n.sm-restore-section h4 {\n  font-size: 12px;\n  font-weight: 700;\n  color: #333;\n  margin: 0 0 8px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid #eee;\n}\n.sm-restore-section ul {\n  margin: 0;\n  padding-left: 16px;\n  font-size: 12px;\n  color: #555;\n  line-height: 1.9;\n}\n\n/* 복구 단계 */\n.sm-restore-step {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 12px;\n  align-items: flex-start;\n}\n.sm-step-num {\n  min-width: 22px;\n  height: 22px;\n  background: #1976d2;\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n.sm-step-body { flex: 1; min-width: 0; }\n.sm-step-title {\n  font-size: 12px;\n  color: #444;\n  margin-bottom: 5px;\n}\n.sm-step-example {\n  font-size: 11px;\n  color: #888;\n  margin-top: 4px;\n  word-break: break-all;\n  line-height: 1.6;\n}\n\n/* 명령어 행 */\n.sm-cmd-line {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #f5f5f5;\n  border: 1px solid #e0e0e0;\n  border-radius: 3px;\n  padding: 5px 8px;\n  margin-bottom: 4px;\n}\n.sm-cmd-line code {\n  flex: 1;\n  font-size: 11px;\n  font-family: 'Consolas', 'Courier New', monospace;\n  color: #333;\n  word-break: break-all;\n}\n.sm-copy-btn {\n  background: none;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 10px;\n  padding: 2px 6px;\n  cursor: pointer;\n  color: #666;\n  flex-shrink: 0;\n  white-space: nowrap;\n  transition: background 0.1s;\n}\n.sm-copy-btn.copied {\n  background: #e8f5e9;\n  border-color: #a5d6a7;\n  color: #2e7d32;\n}\n.sm-copy-btn:hover:not(.copied) { background: #e8e8e8; }\n\n/* 복구 후 팁 */\n.sm-restore-tip {\n  background: #e3f2fd;\n  border: 1px solid #90caf9;\n  border-radius: 5px;\n  padding: 9px 12px;\n  font-size: 12px;\n  color: #1565c0;\n  line-height: 1.7;\n}\n\n/* ── 접근 불가 메시지 ───────────────────────────────────────── */\n.sm-no-access {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  font-size: 14px;\n  color: #aaa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
